import moment from 'moment';
import { numberFormatter } from 'components/atoms/currency-renderer';
import { defaultFormat } from 'utils/date-field/formatter';
import { FinancialsZoomLevel } from '../types/common';
export const hoursToMins = (hours)=>hours * 60;
export const minsToHours = (mins)=>numberFormatter(mins / 60);
export const percentageRenderer = (value)=>`${value}%`;
export const getFilteredZoomLevels = (zoomLevels, calendarEngine, startDate, endDate)=>{
    if (startDate == null || endDate == null) {
        return [];
    }
    let monthCount = 0;
    let currDate = defaultFormat(calendarEngine.toStartOf(moment(startDate), 'month'));
    while(moment(currDate).isSameOrBefore(moment(endDate))){
        monthCount += 1;
        currDate = defaultFormat(calendarEngine.addDuration(moment(currDate), 'month', 1));
    }
    return zoomLevels.filter((zoomLevel)=>monthCount >= 6 || zoomLevel !== FinancialsZoomLevel.Quarterly);
};
export const getDateCategoriesBasedOnDuration = ({ startDate, endDate }, zoomLevel, calendarEngine)=>{
    const columns = [];
    if (startDate == null || endDate == null) {
        return [];
    }
    if (zoomLevel === FinancialsZoomLevel.Overall) {
        return [
            startDate
        ];
    }
    if (zoomLevel === FinancialsZoomLevel.Period) {
        // TODO: handle periodic columns
        return [];
    }
    let currDate = zoomLevel === FinancialsZoomLevel.Monthly ? defaultFormat(calendarEngine.toStartOf(moment(startDate), 'month')) : defaultFormat(calendarEngine.toStartOf(moment(startDate), 'quarter'));
    while(moment(currDate).isSameOrBefore(moment(endDate))){
        columns.push(currDate);
        currDate = defaultFormat(calendarEngine.addDuration(moment(currDate), zoomLevel === FinancialsZoomLevel.Monthly ? 'month' : 'quarter', 1));
    }
    return columns;
};
